/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerimeterPointDto } from './PerimeterPointDto';
import {
    PerimeterPointDtoFromJSON,
    PerimeterPointDtoFromJSONTyped,
    PerimeterPointDtoToJSON,
    PerimeterPointDtoToJSONTyped,
} from './PerimeterPointDto';

/**
 * 
 * @export
 * @interface CreateSiteRequestDto
 */
export interface CreateSiteRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSiteRequestDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSiteRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSiteRequestDto
     */
    address?: string | null;
    /**
     * French postal code (5 digits).
     * @type {string}
     * @memberof CreateSiteRequestDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSiteRequestDto
     */
    cityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSiteRequestDto
     */
    provinceCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSiteRequestDto
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSiteRequestDto
     */
    longitude?: number | null;
    /**
     * Polygon perimeter points describing the covered area.
     * @type {Array<PerimeterPointDto>}
     * @memberof CreateSiteRequestDto
     */
    perimeter?: Array<PerimeterPointDto> | null;
}

/**
 * Check if a given object implements the CreateSiteRequestDto interface.
 */
export function instanceOfCreateSiteRequestDto(value: object): value is CreateSiteRequestDto {
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateSiteRequestDtoFromJSON(json: any): CreateSiteRequestDto {
    return CreateSiteRequestDtoFromJSONTyped(json, false);
}

export function CreateSiteRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSiteRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'],
        'name': json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'cityCode': json['cityCode'] == null ? undefined : json['cityCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'perimeter': json['perimeter'] == null ? undefined : ((json['perimeter'] as Array<any>).map(PerimeterPointDtoFromJSON)),
    };
}

export function CreateSiteRequestDtoToJSON(json: any): CreateSiteRequestDto {
    return CreateSiteRequestDtoToJSONTyped(json, false);
}

export function CreateSiteRequestDtoToJSONTyped(value?: CreateSiteRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationId': value['organizationId'],
        'name': value['name'],
        'address': value['address'],
        'postalCode': value['postalCode'],
        'cityCode': value['cityCode'],
        'provinceCode': value['provinceCode'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'perimeter': value['perimeter'] == null ? undefined : ((value['perimeter'] as Array<any>).map(PerimeterPointDtoToJSON)),
    };
}

